import { temp as actions } from "actions";
import { statuses } from "api";

const initialState = {
   get: {
      status: statuses.idle,
   },
   search: {
      status: statuses.idle,
   },
   insert: {
      status: statuses.idle,
   },
   update: {
      status: statuses.idle,
   },
   delete: {
      status: statuses.idle,
   },
   set: {
      status: statuses.idle,
   },
   sync: {
      status: statuses.idle,
   },
   orderClone: {
      status: statuses.idle,
   },
};

function tempSaga(state = initialState, { type, payload }: any) {
   switch (type) {
      case actions.get.send:
         return {
            ...state,
            get: {
               status: statuses.pending,
               ...payload,
            },
         };
      case actions.get.success:
         return {
            ...state,
            get: {
               status: statuses.resolved,
               ...payload,
            },
         };
      case actions.get.fail:
         return {
            ...state,
            get: {
               status: statuses.rejected,
               reset: actions.get.reset,
               ...payload,
            },
         };
      case actions.get.reset:
         return {
            ...state,
            get: {
               status: statuses.idle,
               ...payload,
            },
         };
      case actions.set.send:
         return {
            ...state,
            set: {
               status: statuses.pending,
               ...payload,
            },
         };
      case actions.set.success:
         return {
            ...state,
            set: {
               status: statuses.resolved,
               ...payload,
            },
         };
      case actions.set.fail:
         return {
            ...state,
            set: {
               status: statuses.rejected,
               reset: actions.set.reset,
               ...payload,
            },
         };
      case actions.set.reset:
         return {
            ...state,
            set: {
               status: statuses.idle,
               ...payload,
            },
         };
      case actions.sync.send:
         return {
            ...state,
            sync: {
               status: statuses.pending,
               ...payload,
            },
         };
      case actions.sync.success:
         return {
            ...state,
            sync: {
               status: statuses.resolved,
               ...payload,
            },
         };
      case actions.sync.fail:
         return {
            ...state,
            sync: {
               status: statuses.rejected,
               reset: actions.sync.reset,
               ...payload,
            },
         };
      case actions.sync.reset:
         return {
            ...state,
            sync: {
               status: statuses.idle,
               ...payload,
            },
         };

      case actions.orderClone.send:
         return {
            ...state,
            orderClone: {
               status: statuses.pending,
               ...payload,
            },
         };
      case actions.orderClone.success:
         return {
            ...state,
            orderClone: {
               status: statuses.resolved,
               ...payload,
            },
         };
      case actions.orderClone.fail:
         return {
            ...state,
            orderClone: {
               status: statuses.rejected,
               reset: actions.orderClone.reset,
               ...payload,
            },
         };
      case actions.orderClone.reset:
         return {
            ...state,
            orderClone: {
               status: statuses.idle,
               ...payload,
            },
         };
      default:
         return state;
   }
}

export default tempSaga;

export { actions };
export { tempSaga };
